import type { Store } from '../data/store';
import { isMarysStore, isTestStore } from '../data/store';

// Reads the server-computed flag. The hardcoded allowlist is a transitional
// fallback for the deploy window (old backend hasn't sent `features` yet) and
// rehydrated cache; remove once web receiving is fully rolled out via the flag.
export const isReceivingEnabled = (store: Store): boolean =>
  store.features?.web_receiving ?? (isMarysStore(store) || isTestStore(store));

// Reads the server-computed rollout flag. Unlike isReceivingEnabled there is
// deliberately NO hardcoded allowlist fallback: a store whose `features` block
// is missing (old backend, or a cache entry rehydrated past Yup's defaults)
// must read as v1, because a v2 UI on a store the server still scrubs would
// show every suggestion as zero.
export const isOrderEditV2Enabled = (store: Store): boolean =>
  store.features?.order_edit_v2 ?? false;
